export default __webpack_public_path__ + "static/banner-best-food-wine-festivals-Australia-2019-6098a9ce9311a3a84922e73e219aa7fd.jpg";